import React from "react";

import style from "../../assets/css/components/Chart/Chart.module.css";
import tinycolor from "tinycolor2";
import ReactApexChart from "react-apexcharts";

function DataTeam({ teamColor, series }) {
  const options = {
    chart: {
      height: 350,
      type: "radar",
      toolbar: {
        show: false,
      },
    },
    colors: [
      tinycolor.readability("#17171d", teamColor) <= 2
        ? tinycolor
            .mostReadable("#17171d", ["#00dd80", teamColor])
            .toHexString()
        : teamColor,
    ],

    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      radar: {
        polygons: {
          strokeColors: "#848486",
          connectorColors: "#848486",
        },
      },
    },
    xaxis: {
      categories: ["JG", "GF", "GE", "TR", "TA"],
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "0",
        },
      },
    },
    tooltip: {
      theme: "dark",
    },
  };

  return (
    <>
      <ReactApexChart
        className={style.chart}
        options={options}
        series={series}
        type="radar"
        width={"100%"}
        height={"100%"}
      />
    </>
  );
}

export default DataTeam;
